"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonInputs = exports.flattenInput = void 0;
exports.flattenInput = {
    baseStyle: {
        borderRadius: '8px',
        _focus: {
            borderColor: 'blue.600',
            boxShadow: '0 0 0 2px rgba(59, 130, 246)',
        },
    },
    sizes: {
        lg: {
            fontSize: '1rem',
        },
    },
    variants: {
        base: {
            _disabled: {
                opacity: 1,
            },
            _invalid: {
                borderColor: 'red.light',
            },
            border: '1px solid',
            borderColor: 'gray.400',
            bg: 'white.200',
        },
    },
    defaultProps: {
        size: 'lg',
        variant: 'base',
    },
};
exports.commonInputs = {
    baseStyle: {
        field: exports.flattenInput.baseStyle,
    },
    sizes: {
        lg: {
            field: exports.flattenInput.sizes.lg,
        },
    },
    variants: {
        base: {
            field: exports.flattenInput.variants.base,
        },
    },
    defaultProps: exports.flattenInput.defaultProps,
};
exports.default = {
    Input: exports.commonInputs,
    Select: exports.commonInputs,
    NumberInput: exports.commonInputs,
    Textarea: exports.flattenInput,
};
